import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(10 * 60 + 48); // 10 minutes 48 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 py-3 px-4 shadow-md text-center font-bold text-sm md:text-base flex items-center justify-center gap-2" data-id="element-30">
      <Clock className="w-5 h-5 animate-pulse" data-id="element-31" />
      <span data-id="element-32">
        Esta oferta termina pronto:{' '}
        <span className="font-mono text-lg bg-red-800 px-2 py-0.5 rounded ml-1" data-id="element-33">
          {formatTime(timeLeft)}
        </span>
      </span>
    </div>;
}